export { default } from "./CancelarIngredientes";
